import IconButton from '@mui/material/IconButton';
import { useDispatch } from 'react-redux';
import ABSSvgIcon from '@abs/core/ABSSvgIcon';
import { toggleHelpPanel } from './store/stateSlice';
import { useTranslation } from 'react-i18next';
import Tooltip from '@mui/material/Tooltip';

function HelpPanelToggleButton(props) {
  const dispatch = useDispatch();
  const { t } = useTranslation('abslayouts');

  return (
    <Tooltip title={t('HELPPANEL_TOOLTIP')} placement="bottom">
      <IconButton className="w-40 h-40" onClick={(ev) => dispatch(toggleHelpPanel())} size="large">
        {props.children}
      </IconButton>
    </Tooltip>
  );
}

HelpPanelToggleButton.defaultProps = {
  children: <ABSSvgIcon>material-outline:help_outline</ABSSvgIcon>,
};

export default HelpPanelToggleButton;
